<template>
    <div class="ufo--accordion">
        <div
            v-for="(item, index) in accordionItems"
            :key="`accordion-view-item-${index}`"
            :class="['accordion-item', { open: isItemOpen(index), 'with-divider': settings.showDivider }]"
            :style="itemStyle"
        >
            <button
                :class="['accordion-trigger', `icon-${settings.iconPlacement}`]"
                type="button"
                @click="toggleItem(index)"
            >
                <span
                    :class="[
                        'accordion-icon',
                        `style-${settings.iconStyle}`,
                        { 'is-open': isItemOpen(index) }
                    ]"
                    :style="getTitleIconStyle(item.title.text)"
                >
                    <span v-if="settings.iconStyle === 'plus'" class="accordion-plusminus" />
                    <Icon
                        v-else
                        :width="24"
                        :height="24"
                        :icon-name="settings.iconStyle === 'arrow' ? 'arrow-down' : 'chevron-down'"
                    />
                </span>
                <span class="accordion-title">
                    <GetSectionText :section-text="item.title" />
                </span>
            </button>

            <div :class="['accordion-content-shell', { 'is-open': isItemOpen(index) }]">
                <div class="accordion-content">
                    <GetSectionText :section-text="item.content" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/scripts/common/Icon.vue";
import GetSectionText from "@/scripts/view/portfolio/sections/_helper/GetSectionText.vue";

export default {
    name: "Accordion",
    components: {
        GetSectionText,
        Icon,
    },
    props: {
        section: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            openItemIndices: [],
        };
    },
    computed: {
        accordionItems() {
            return this.section.accordionItems;
        },
        settings() {
            return this.section.accordionSettings;
        },
        itemStyle() {
            return {
                '--accordion-divider-width': `${this.settings.dividerLineWeight}px`,
            };
        }
    },
    mounted() {
        this.resetOpenItems();
    },
    watch: {
        "section.accordionSettings.openFirstItemByDefault"() {
            this.resetOpenItems();
        },
        "section.accordionSettings.allowMultipleOpenItems"(next) {
            if (!next && this.openItemIndices.length > 1) {
                this.openItemIndices = this.openItemIndices.slice(0, 1);
            }
        }
    },
    methods: {
        resetOpenItems() {
            this.openItemIndices = this.settings.openFirstItemByDefault ? [0] : [];
        },
        getTitleNodeType(titleHtml) {
            if (/<h1[\s>]/i.test(titleHtml)) return 'h1';
            if (/<h2[\s>]/i.test(titleHtml)) return 'h2';
            if (/<h3[\s>]/i.test(titleHtml)) return 'h3';
            if (/<h4[\s>]/i.test(titleHtml)) return 'h4';
            return 'p1';
        },
        getTitleIconStyle(titleHtml) {
            const nodeType = this.getTitleNodeType(titleHtml);
            return {
                color: `var(--section-${nodeType}-text-color)`,
            };
        },
        isItemOpen(index) {
            return this.openItemIndices.includes(index);
        },
        toggleItem(index) {
            if (this.isItemOpen(index)) {
                this.openItemIndices = this.openItemIndices.filter((itemIndex) => itemIndex !== index);
                return;
            }

            if (this.settings.allowMultipleOpenItems) {
                this.openItemIndices = [...this.openItemIndices, index];
                return;
            }

            this.openItemIndices = [index];
        },
    }
}
</script>

<style lang="scss">
@import "@/styles/components/sections/_accordion-section.scss";
</style>

<style lang="scss" scoped>
.ufo--accordion {
    .accordion-trigger {
        width: 100%;
        border: none;
        background: transparent;
        padding: 0;
        text-align: left;
        cursor: pointer;
        color: inherit;
    }
}
</style>
